import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import accountsStore from 'store/accountsStore';

const menuUseStyles = makeStyles({
  paper: {
    boxShadow: '1px 1px 6px rgba(0, 0, 0, 0.12)',
  },
  list: {
    padding: '4px 0',
  },
});

const itemUseStyles = makeStyles({
  root: {
    fontFamily: 'var(--ff-etelka-text)',
    fontSize: 12,
    color: '#222736',
    padding: '9px 8px',
    borderBottom: '1px solid #EEEFF3',
    fontStyle: 'normal',
    fontWeight: 'normal',
    '&:last-child': {
      borderWidth: 0,
    },
  },
});

interface IAccountSelectorProps {
  onAccountChanged?: (account: string) => void;
}

const AccountSelector: React.FunctionComponent<IAccountSelectorProps> = (props) => {
  const { onAccountChanged } = props;

  const [isMenuOpen, setMenuOpen] = useState(false);

  const itemStyle = itemUseStyles();

  const { activeAccountNumber, accounts } = accountsStore;

  const accountsList = accounts.map((account) => account.accountNumber);

  const [currentAccount, setAccount] = useState<string>('');

  useEffect(() => {
    setAccount(currentAccount || '');
  }, [currentAccount]);

  useEffect(() => {
    setAccount(activeAccountNumber || '');
  }, [activeAccountNumber]);

  const handleAccountChange = (event: React.ChangeEvent<any>) => {
    setAccount(event.target.value);
  };

  useEffect(() => {
    if (onAccountChanged) onAccountChanged(currentAccount);
  }, [currentAccount, onAccountChanged]);

  const selectUseStyles = makeStyles({
    root: {
      height: 32,
      boxSizing: 'border-box',
      borderRadius: 4,
      background: '#F6F7F9',
      color: '#7D8598',
      fontFamily: 'var(--ff-etelka-text)',
      fontSize: 12,
    },
    select: {
      padding: '8px 12px',
      boxShadow: isMenuOpen ? '0 0 0 1px #BBBFC9' : 'none',
      '&:focus': {
        borderRadius: 4,
      },
    },
    icon: {
      color: '#BBBFC9',
      marginRight: 4,
    },
  });

  const renderSelectValue = (value) => <span style={{ marginRight: 6 }}>Account {value}</span>;
  const openSelector = () => setMenuOpen(true);
  const closeSelector = () => setMenuOpen(false);

  return (
    <FormControl style={{ width: '100%' }}>
      <Select
        value={currentAccount}
        renderValue={renderSelectValue}
        IconComponent={ExpandMoreRoundedIcon}
        onChange={handleAccountChange}
        disableUnderline
        classes={selectUseStyles()}
        MenuProps={{
          variant: 'menu',
          classes: menuUseStyles(),
          transformOrigin: { vertical: -47, horizontal: 'left' },
        }}
        onOpen={openSelector}
        onClose={closeSelector}
      >
        {accountsList.map((account) => (
          <MenuItem value={account} key={account} classes={itemStyle}>
            {account}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default observer(AccountSelector);
